import request from '@/utils/request'
import Vue from 'vue'
import signMd5Utils from '@/utils/encryption/signMd5Utils'

const service = process.env.VUE_APP_YUNNONG_URL;


//post
export function postAction(url, parameter) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString() };

    return request({
        url: service + url,
        method: 'post',
        data: parameter,
        headers: signHeader
    })
}

//post method= {post | put}
export function httpAction(url, parameter, method) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString() };

    return request({
        url: service + url,
        method: method,
        data: parameter,
        headers: signHeader,
        timeout: 30000
    })
}

//put
export function putAction(url, parameter) {
    return request({
        url: service + url,
        method: 'put',
        data: parameter
    })
}

//get
export function getAction(url, parameter) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString() };

    return request({
        url: service + url,
        method: 'get',
        params: {
            _t: Date.parse(new Date()) / 1000,
            ...parameter
        },
        headers: signHeader
    })
}

//deleteAction
export function deleteAction(url, parameter) {
    return request({
        url: service + url,
        method: 'delete',
        params: parameter
    });
}

//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/sys/dict/getDictItems/${code}`, params);

/**
 * 获取字典数组
 * @param dictCode 字典Code
 * @return List<Map>
 */
export async function initDictOptions(dictCode) {
    if (!dictCode) {
        return '字典Code不能为空!';
    }
    //获取字典数组
    let res = await ajaxGetDictItems(dictCode);
    return res;
}

/**
 * 翻译字段值对应的文本
 * @param children
 * @returns string
 */
export async function filterDictText(dictCode, key) {
    if (key == null || key.length == 0) {
        return;
    }
    if (!dictCode) {
        return '字典Code不能为空!';
    }
    /* //优先从缓存中读取字典配置
  if(initDictOptions(dictCode)){
	  
  } */
    var res = await initDictOptions(dictCode);
    return res
}